import React from 'react-x';
import propTypes from 'prop-types-x';
import { TextContent } from './TextContent.jsx';
import { Button } from './Button.jsx';

export function AlertTextContent(props) {

  const {
    imgUrl,
    heading,
    subheading,
    body,
    buttonLabel,
    linkHref,
    onClickCallback,
    secondaryButtonLabel,
    secondaryLinkHref,
    secondaryOnClickCallback
  } = props;

  const block = 'c-alert-text-content';

  return (
    <div className={block}>
      {imgUrl && 
        <img
        className={`${block}__image`}
        src={imgUrl}
        alt='Alert text icon'
        aria-hidden
        />
      }
      <TextContent 
      heading={heading}
      subheading={subheading}
      body={body}
      modifier='centered'
      cssAnimation={false}
      />
      <div className={`${block}__ctas`}>
        {buttonLabel && 
          <Button 
          label={buttonLabel}
          type='primary' 
          href={linkHref}
          cssAnimation={false} 
          onClickCallback={onClickCallback}
          /> 
        }
        {secondaryButtonLabel && 
          <Button 
          label={secondaryButtonLabel}
          type='secondary' 
          href={secondaryLinkHref}
          cssAnimation={false} 
          onClickCallback={secondaryOnClickCallback}
          /> 
        }
      </div>
    </div>
  );
};

AlertTextContent.propTypes = {
  imgUrl: propTypes.string,
  heading: propTypes.string,
  subheading: propTypes.string,
  body: propTypes.string,
  buttonLabelL: propTypes.string,
  onClickCallback: propTypes.func,
};

AlertTextContent.defaultProps = {
  onClickCallback: () => {}
};